// PA-D tier loading. The four tier definitions are JSON data files shipped
// verbatim (data/README rules apply: never edit a word). Full JSON-schema
// validation runs in the test suite only (ajv stays a devDependency and out
// of the production bundle — Step 0 decision 8); this loader does a light
// structural check so a malformed tier fails loudly at runtime instead of
// rendering a half-empty HUD.

import fourK from '../data/pa-4k.json';
import kindergarten from '../data/pa-kindergarten.json';
import grade1 from '../data/pa-grade1.json';
import grade23 from '../data/pa-grade2-3.json';

const TIERS = {
  '4k': fourK,
  k: kindergarten,
  grade1,
  'grade2-3': grade23,
};

// Segmented-control order (Step 3b): 4K | Kindergarten | Grade 1 | Grades 2-3.
export const PAD_TIER_IDS = ['4k', 'k', 'grade1', 'grade2-3'];

function checkTier(tierId, tier) {
  if (!tier || tier.moduleId !== 'pa_diagnostic') {
    throw new Error(`PA-D tier ${tierId}: wrong or missing moduleId`);
  }
  if (tier.tierId !== tierId) {
    throw new Error(`PA-D tier ${tierId}: file says tierId ${tier.tierId}`);
  }
  if (!Array.isArray(tier.subskills) || tier.subskills.length < 3 || tier.subskills.length > 6) {
    throw new Error(`PA-D tier ${tierId}: expected 3-6 subskills`);
  }
  for (const s of tier.subskills) {
    if (typeof s.id !== 'string' || !s.id.startsWith('pad_')) {
      throw new Error(`PA-D tier ${tierId}: subskill id ${s.id} is not pad_*`);
    }
    if (!Array.isArray(s.items) || s.items.length !== tier.itemsPerSubskill) {
      throw new Error(`PA-D tier ${tierId}: subskill ${s.id} needs exactly ${tier.itemsPerSubskill} items`);
    }
  }
  return tier;
}

/** @returns the verbatim tier definition; throws on unknown id or bad shape. */
export function loadTier(tierId) {
  const tier = TIERS[tierId];
  if (!tier) throw new Error(`PA-D: unknown tier ${tierId}`);
  return checkTier(tierId, tier);
}

/** All four tiers in segmented-control order (for the tier switch + tests). */
export function listTiers() {
  return PAD_TIER_IDS.map((id) => loadTier(id));
}
